var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"text text-title text-center text-danger"},[_vm._v(_vm._s(_vm.localize.title))]),_c('p',{staticClass:"text text-center padding"},[_vm._v(_vm._s(_vm.localize.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }